import React, { useState } from 'react'

import { useQuery } from '@tanstack/react-query'
import { isAfter } from 'date-fns'
import { Check } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

import { cn } from '@fortem-monorepo/js-utilities'
import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { useApi } from '@fortem-monorepo/react-spa'
import { DatePickerWithControls } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { CommandGroup, CommandItem, CommandSeparator } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { SchemaType } from './DeleteProviderTaskDataForm.schema'

export interface DeleteProviderTaskDataFormFieldsProps {
  dates: {
    st_dt: string
    ed_dt: string
  }
}

export const DeleteProviderTaskDataFormFields: React.FC<DeleteProviderTaskDataFormFieldsProps> = ({
  dates: _dates,
}) => {
  const { setValue, control } = useFormContext<SchemaType>()
  const [open, setOpen] = useState(false)

  const api = useApi()

  const feedListQuery = useQuery({
    queryKey: ['feeds', 'scheduled-tasks', 'feed-list'],
    queryFn: () => api.feeds.getFeedsList(),
  })

  // const ntDataQuery = useQuery({ ...feedsNTOptions(dates) })
  // const providersDataQuery = useQuery({ ...feedsProvidersOptions(dates) })

  // const activeDates = useMemo(() => {}, [provider_id, feed_id])

  return (
    <div className={'flex flex-col gap-4'}>
      <FormField
        name="table_name"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <div className="flex items-center gap-2">
                <FormLabel>Task</FormLabel>
                <FormError />
              </div>
              <SearchSelect
                open={open}
                setOpen={setOpen}
                value={value}
                loading={feedListQuery.isFetching}
                placeholder={'Select a task...'}
                options={(feedListQuery.data ?? []).reduce(
                  (prev, current) => {
                    return [
                      ...prev,
                      ...current.feeds.map(({ feed_name, feed_id }) => {
                        const identifier = `${current.provider_id}.${feed_id}`

                        return {
                          label: `${current.provider_name} ${feed_name}`,
                          value: identifier,
                        }
                      }),
                    ]
                  },
                  [] as { label: string; value: string }[],
                )}
              >
                {(feedListQuery.data ?? []).map((provider, index) => {
                  return (
                    <React.Fragment key={provider.provider_id}>
                      {index !== 0 && <CommandSeparator />}
                      <CommandGroup heading={provider.provider_name.toUpperCase()}>
                        {provider.feeds.map((feed) => {
                          const is_selected = `${provider.provider_id}.${feed.feed_id}` === value

                          return (
                            <CommandItem
                              value={`${provider.provider_id}.${feed.feed_id}`}
                              onSelect={(val) => {
                                setValue('table_name', val, {
                                  shouldValidate: true,
                                })
                                setOpen(false)
                              }}
                              disabled={is_selected}
                              key={feed.feed_id}
                            >
                              <div className={'flex items-center gap-2 justify-between w-full'}>
                                <span>
                                  {provider.provider_name.toUpperCase()} {feed.feed_name}
                                </span>
                                {is_selected && (
                                  <Check className={cn('text-green-700 ml-auto h-4 w-4')} />
                                )}
                              </div>
                            </CommandItem>
                          )
                        })}
                      </CommandGroup>
                    </React.Fragment>
                  )
                })}
              </SearchSelect>
            </FormItem>
          )
        }}
      />
      <FormField
        name="value_date"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <div className="flex items-center gap-2">
                <FormLabel>Date</FormLabel>
                <FormError />
              </div>
              <DatePickerWithControls
                // todayButton={{ date: new Date(dates.ed_dt), enabled: true, text: "Most recent" }}
                todayButton={{ date: new Date(), enabled: true }}
                size="sm"
                selected={value ? new Date(value) : undefined}
                disabled={(date) => {
                  // const _before = isBefore(date, new Date(dates.st_dt))
                  // const _after = isAfter(date, new Date(dates.ed_dt))
                  // return _before || _after
                  return isAfter(date, new Date())
                }}
                onSelect={(date) =>
                  // @ts-expect-error
                  setValue('value_date', date ? toISO8601(date) : undefined, {
                    shouldValidate: true,
                  })
                }
              />
            </FormItem>
          )
        }}
      />
    </div>
  )
}
